import { Module } from "@/modules/tenantAdmin/enums";

export default [
  {
    path: "/boeken",
    meta: {
      module: Module.Appointment,
    },
    children: [
      {
        path: "",
        name: "appointment.tool",
        component: () =>
          import("@/modules/shared/appointment/views/AppointmentTool.vue"),
      },
      {
        path: "klant/:customerId",
        name: "appointment.tool.customer",
        component: () =>
          import("@/modules/shared/appointment/views/AppointmentTool.vue"),
      },
    ],
  },
];
